import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/4.jpg'
import timg5 from '../images/team/5.jpg'
import timg6 from '../images/team/6.jpg'


const Teams = [
    {
       id:'1',
       tImg:timg1,
       name:'Kshitij Raj Lohani',
       title:'Founder',  
       location: 'Austin, USA',   
    },
    {
       id:'2',
       tImg:timg2,
       name:'Anamika Nehuray',
       title:'Operations', 
       location: 'Bhaktapur, Nepal',    
    },
    {
       id:'3',
       tImg:timg3,
       name:'Sujay Pal',
       title:'Communication',  
       location: 'Ktm, Nepal',   
    },
    {
       id:'4',
       tImg:timg4,
       name:'Aasutosh Nehuray',
       title:'Digital Media', 
       location: 'Bkt, Nepal',    
    },
    {
       id:'5',
       tImg:timg5,
       name:'Zenefer Marry',
       title:'Volunteer',     
    },
    {
       id:'6',
       tImg:timg6,
       name:'Devid Harmin',
       title:'Volunteer',     
    }
]

export default Teams;